import {types} from './types';

const initialState = {
    groups: null,
    users: null,
}

export function cashierReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GROUPS:
            return { ...state, groups: action.payload};
        case types.SET_USERS: 
            return { ...state, users: action.payload};
        default:
            return state
    }
}